import httpClient from '../httpClient';

export async function getInforme(id: string) {
  try {
    const response = await httpClient.get(`/api/informessisdaf/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter informe: ' + error);
  }
}

export async function getAllInformes() {
  try {
    const response = await httpClient.get(`/api/informessisdaf`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de informes: ' + error);
  }
}
